import { render, staticRenderFns } from "./dialogChangeVega.vue?vue&type=template&id=4093abd4"
import script from "./dialogChangeVega.vue?vue&type=script&lang=js"
export * from "./dialogChangeVega.vue?vue&type=script&lang=js"
import style0 from "./dialogChangeVega.vue?vue&type=style&index=0&id=4093abd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports